import api from '@shared/services/api.js';

export default {
  async getBenchmarkBids() {
    const url = '/api/market/bids';
    const data = await api.get(url);
    return data;
  },
};
